const { __ } = wp.i18n;
const {
	registerBlockType
} = wp.blocks;

const {
	InspectorControls,
} = wp.blockEditor;
const {
	SelectControl,
	ToggleControl,
	PanelBody,
	Disabled
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( 'wp-apidae/dynamic-content', {
	title: __("Contenu Dynamique", "wp-apidae"), // Block title.
	description: __("Affiche une information issue de la fiche Apidae.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.dynamicContent
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		dynamic_content_field: {
			type: 'string',
			default: 'nom',
		},
		field_tag: {
			type: 'string',
			default: 'div',
		},
		callback: {
			type: 'string',
			default: '',
		},
		post_link: {
			type: 'boolean',
			default: false,
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props              = this.props;
			const attributes         = props.attributes;
			const fieldsOptions      = window.WpApidaeTemplateData.fieldsOptions;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;
			const callbackOptions    = window.WpApidaeTemplateData.callbackOptions;

			var template = window.WpApidaeTemplateData.settings;

			return [
				props.isSelected && (
					<InspectorControls
							key={ 'inspector' }
						>
						<PanelBody title={ __( 'General' ) }>
						<SelectControl
							label={ __( 'Champs' ) }
							value={ attributes.dynamic_content_field }
							options={fieldsOptions}
							onChange={ newValue => {
								props.setAttributes({
									dynamic_content_field: newValue,
								});
							}}
						/>
						<SelectControl
							label={ __( 'Balise' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>
						<SelectControl
							label={ __( 'Callback' ) }
							value={ attributes.callback }
							options={callbackOptions}
							onChange={ newValue => {
								props.setAttributes({
									callback: newValue,
								});
							}}
						/>
						<ToggleControl
								label={ __( 'Inclure le lien du post' ) }
								checked={ attributes.post_link }
								onChange={ () => {
									props.setAttributes({ post_link: ! attributes.post_link });
								} }
							/>
						</PanelBody>
					</InspectorControls>
				),
				<Disabled>
					<ServerSideRender
					block="wp-apidae/dynamic-content"
					attributes={ attributes }
					urlQueryArgs={{
						settings:template
					}}
					/>
				</Disabled>
			]

		}
	},

	save: () => {
    return null;
  },
} );
